<template>
  <div class="auth-wrapper auth-v2 login-page">
    <a
      :href="$oldSiteUrl"
      class="login-page__old-site-link font-weight-bold"
      target="_blank"
    ><locale /> {{ $t('Old interpretation of the site') }} </a>

    <b-row class="auth-inner m-0">
      <b-col
        cols="12"
        class="login-page__content d-flex align-items-center justify-content-center px-2"
      >
        <div class="login-page__panel">
          <b-card-title
            class="login-page__title font-weight-bold text-center"
            title-tag="h2"
          >
            DARAJA.ILMIY.UZ
          </b-card-title>

          <p class="login-page__subtitle text-center">
            {{ $t('Unified electronic system of coordination of postgraduate education') }}
          </p>

          <b-button
            block
            variant="primary"
            class="one-btn login-page__science-id"
            @click="scienceId"
          >
            <feather-icon
              icon="LogInIcon"
              size="22"
              class="mr-50"
            />
            <span>{{ $t('Sign in with Science ID') }}</span>
          </b-button>

          <b-card-text class="login-page__foreign text-center mb-0">
            <span>{{ $t('Are you a foreigner?') }} </span>
            <b-link :to="{name:'auth-login-foreign'}">
              <span>&nbsp;{{ $t('Login as a foreign user') }} </span>
            </b-link>
          </b-card-text>
        </div>

        <a
          :href="$technicalAdminLink"
          class="login-page__technical-admin font-medium-2"
          target="_blank"
        >
          <feather-icon
            icon="SendIcon"
            size="15"
          />
          {{ $t('Technical admin') }}
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BLink, BCardText, BCardTitle, BButton, VBTooltip,
} from 'bootstrap-vue'
import Locale from '@/layouts/components/app-navbar/components/Locale.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BCardText,
    BCardTitle,
    BButton,
    Locale,
  },
  methods: {
    scienceId() {
      this.$store.dispatch('oneID/login')
    },
  },
}
</script>

<style lang="scss">
@import './auth-modern.scss';
</style>
